import { PropsWithChildren, useState } from "react";
import { FaCaretRight } from "react-icons/fa";
import { HiLightningBolt } from "react-icons/hi";

import { cn } from "@bentolabs/kit/utils";

import BentoLogo from "shared/assets/bento-logo.svg?react";

import { DetailsDialog } from "../details-dialog/details-dialog";
import { DetailsBentoContent } from "./details-bento-content";

type Props = {
  className?: string;
};

export const BentoContent = (props: PropsWithChildren<Props>) => {
  const { className } = props;

  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="flex flex-col items-center text-white">
      <div
        className={cn(
          "text-ultramarine-blue mt-14.5 flex items-center gap-1.5",
          className
        )}
      >
        <HiLightningBolt
          style={{
            fill: "radial-gradient(55.5% 56.44% at 57.52% 45.81%, #89A5FF 0%, #3B69FF 100%)",
          }}
        />

        <div>Boosted APY</div>
      </div>

      <div className="relative mt-3.5 flex items-center justify-center">
        <div className="inline-flex text-7xl leading-none">15.5%</div>
      </div>

      <button
        className="mt-7 flex cursor-pointer items-center text-white/50 outline-hidden transition-colors hover:text-white/70"
        onClick={() => {
          setIsOpen(!isOpen);
        }}
      >
        More details
        <FaCaretRight className="ml-2 size-4" />
      </button>

      <DetailsDialog
        title="Bento Yield Farm"
        className="text-ultramarine-blue"
        img={<BentoLogo className="size-full text-black" />}
        isOpen={isOpen}
        onOpenChange={setIsOpen}
      >
        <DetailsBentoContent />
      </DetailsDialog>
    </div>
  );
};
